import { EntityDrawer } from '@jupiterone/jupiter-web-toolkit';
import React, { useEffect, useState } from 'react';
import { Pack } from '../reducer/packVertices';
import {
  GraphData,
  GraphEdge,
  GraphEntity,
  GraphFilters,
  InspectEdge,
} from '../types';
import { getPackId } from '../utils/packUtils';
import PackDrawer from './PackDrawer/PackDrawer';
import RelationshipDrawerContainer from './RelationshipDrawer/RelationshipDrawerContainer';

interface Props {
  graphData: GraphData;
  allPacks: Pack[];
  selectedNodeId: string | null;
  selectedEdgeId: string | null;
  open: boolean;
  onClose: VoidFunction;
  filters: GraphFilters;
  onChangeFilters: (filters: GraphFilters) => void;
  onUpdateGraph?: VoidFunction;
}

const GraphViewerEntityDrawer = ({
  open,
  allPacks,
  onClose,
  selectedNodeId,
  selectedEdgeId,
  onChangeFilters,
  graphData,
  filters,
  onUpdateGraph,
}: Props) => {
  const [internalSelectedNodeId, setInternalSelectedNodeId] = useState<
    string | null
  >(null);
  const [internalSelectedEdgeId, setInternalSelectedEdgeId] = useState<
    string | null
  >(null);

  useEffect(() => {
    if (selectedEdgeId && selectedEdgeId !== internalSelectedEdgeId) {
      setInternalSelectedEdgeId(selectedEdgeId);
      setInternalSelectedNodeId(null);
    } else if (selectedNodeId && selectedNodeId !== internalSelectedNodeId) {
      setInternalSelectedNodeId(selectedNodeId);
      setInternalSelectedEdgeId(null);
    }
  }, [selectedNodeId, selectedEdgeId]);

  const getInspectedEdge = (): InspectEdge => {
    const edge = graphData.edges.find(
      (e) => e.id === internalSelectedEdgeId
    ) as GraphEdge;
    const relevantVertices = graphData.vertices.filter(
      (v) => v.id === edge?.fromVertexId || v.id === edge?.toVertexId
    );
    const toEntity = relevantVertices.find((v) => v.id === edge?.toVertexId)
      ?.entity as GraphEntity;
    const fromEntity = relevantVertices.find((v) => v.id === edge?.fromVertexId)
      ?.entity as GraphEntity;
    const result = { toEntity, fromEntity, ...edge };
    return result;
  };

  const handleTogglePropertyFilter = (
    propertyName: string,
    propertyValue?: any
  ) => {
    const newProperties = {
      ...filters.properties,
      [propertyName]: propertyValue,
    };
    onChangeFilters({ ...filters, properties: newProperties });
  };

  const pack: Pack | undefined = allPacks.find(
    (p) => getPackId(p) === internalSelectedNodeId
  );

  if (pack) {
    return (
      <PackDrawer
        pack={pack}
        onClose={onClose}
        graphData={graphData}
        onSelectNode={setInternalSelectedNodeId}
      />
    );
  } else if (!internalSelectedEdgeId) {
    return (
      <EntityDrawer
        vertexId={internalSelectedNodeId || undefined}
        onClose={onClose}
        onEditEntity={onUpdateGraph}
        onDeleteEntity={onUpdateGraph}
        propertyFindRelated
        propertyFindSimilar
        propertyActions={[
          { name: 'Filter Graph', callback: handleTogglePropertyFilter },
        ]}
      />
    );
  } else if (internalSelectedEdgeId) {
    return (
      <RelationshipDrawerContainer
        inspectedEdge={getInspectedEdge()}
        isOpen={true}
        onClose={onClose}
      />
    );
  } else {
    return <></>;
  }
};

export default GraphViewerEntityDrawer;
